module.exports = __webpack_public_path__ + "img/screenshot-1.9710674c.png";